module.exports = __webpack_public_path__ + "img/a21.2b5dfeaf.png";